import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { SummaryProps } from './interfaces';
import CircularProgressWithLabel from './CircularProgressWithLabel';
import { useStyles } from './styles';
import {
  getMessageSupport,
  getMessageTimeRemain,
} from 'components/StrategiesList/helpers';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const Summary: React.FC<SummaryProps> = ({
  percent,
  messageTimeRemain,
  status,
  isActivated,
  isOnRunSimulation,
}) => {
  const classes = useStyles();
  const circularProgressColor = 'primary';

  const {
    list: { strategyStatusEnum },
  } = useSelector((state: RootState) => state.parameters);

  const hasSimulationAndIsNotActive = !isActivated;

  const currentMessageTimeRemain = getMessageTimeRemain(
    messageTimeRemain || '',
    status,
  );

  const messageSupport = getMessageSupport(isActivated);

  const showMessage = ['SIMULATING', 'ACTIVE'].includes(status);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      className={classes.container}
    >
      {isOnRunSimulation && (
        <Grid item>
          <CircularProgressWithLabel
            size={100}
            value={percent}
            color={circularProgressColor}
          />
        </Grid>
      )}
      <Grid item>
        <Typography color="textPrimary">
          Situação: {strategyStatusEnum[status] || ''}
        </Typography>
      </Grid>
      {showMessage ? (
        <Grid item>
          <Typography color="textPrimary" variant="body2">
            {hasSimulationAndIsNotActive
              ? currentMessageTimeRemain
              : messageSupport}
          </Typography>
        </Grid>
      ) : null}
    </Grid>
  );
};
export default Summary;
